import React from "react"
import styles from "./styles.module.css"

import { Box, Center, Spinner } from "@chakra-ui/react"
import { useTranslations } from "next-intl"
import { Alert } from "@/shared/ui/alert"

function Marker({
  hover,
  isLoading,
  isLocation = false,
}: {
  hover: boolean
  isLoading: boolean
  isLocation?: boolean
}) {
  const t = useTranslations()
  return (
    <>
      <Box
        className={`${styles.marker} ${hover ? styles.hover : ""}`}
        transform={`translate(-50%, calc(-50% - 35px))`}
      >
        <Center className={styles.head} bgColor={"#EC5962"}>
          <Spinner color="white" opacity={isLoading ? 1 : 0} />
        </Center>
        <div className={styles.stick} />
        <div className={styles.shadow} />
      </Box>
      {isLocation ? (
        <Box
          zIndex={10}
          position="absolute"
          top={{ base: 20, lg: 14 }}
          left="50%"
          transform="translateX(-50%)"
          data-state={Boolean(isLocation) ? "open" : "closed"}
          _open={{
            animationName: "fade-in, scale-in",
            animationDuration: "300ms",
          }}
          _closed={{
            animationName: "fade-out, scale-out",
            animationDuration: "120ms",
          }}
        >
          <Alert
            size="sm"
            rounded={12}
            variant="solid"
            status="warning"
            title={t("geolocation_access_required")}
          />
        </Box>
      ) : null}
    </>
  )
}

export default Marker
